export default {"src":"/_next/static/media/Group 427321302.afba1321.svg","height":15,"width":14,"blurWidth":0,"blurHeight":0};